
import { LocaleContext } from 'router/constants/localeContext';
import { useContext } from 'react';

export const useLocaleContext = () => {
  const { locale, setLocale } = useContext(LocaleContext);

  return { locale, setLocale };
};
